<template>
  <component
    :is="calculatedLink.component"
    :href="calculatedLink.link"
    :class="bem({hasTheme})"
    @click="calculatedLink.ui ? openUIElement(promoStore.banner.link) : null"
  >
    <span :class="bem('text', {'has-mobile-message': !!promoStore.banner.mobileMessage})">{{ promoStore.banner.message }}</span>
    <span
      v-if="promoStore.banner.mobileMessage"
      :class="bem('text-mobile')"
    >{{ promoStore.banner.mobileMessage }}</span>
  </component>
</template>
<script setup lang="ts">
const bem = useBEM('SpecialPromoBanner')
const promoStore = usePromoStore()
const { isLinkOrOpenUI, openUIElement } = useUrlBuilder()

const hasTheme = computed(() => {
  return !!promoStore.theme.id
})

const calculatedLink = computed(() => {
  const isLink = isLinkOrOpenUI(promoStore.banner.link).isLink
  const opensUI = isLinkOrOpenUI(promoStore.banner.link).opensUI
  const component = isLink ? 'a' : opensUI ? 'button' : 'div'
  const link = isLink ? isLinkOrOpenUI(promoStore.banner.link).internalLink : null
  return {
    component,
    link,
    ui: opensUI
  }
})
</script>
<style lang="postcss">
.SpecialPromoBanner {
  @apply relative w-full h-8 flex items-center justify-center;
  background: var(--promo-bg, theme(colors.black));

  &::after {
    @apply content-[''] absolute bottom-0 left-0 right-0 h-px
    bg-gradient-light;
  }
}

.SpecialPromoBanner__text, .SpecialPromoBanner__text-mobile {
  @apply heading-6 t-gradient-light text-center;
}

.SpecialPromoBanner__text {
  @apply transition-all duration-500;

  &--has-mobile-message {
    @apply hidden md:block;
  }
}

.SpecialPromoBanner__text-mobile {
  @apply md:hidden;
}

/** Modifier: has-theme */
.SpecialPromoBanner--has-theme {
  &::after {
    @apply promo-gradient-bg-linear promo-gradient-bg-linear-animated;
  }

  &:hover {
    .SpecialPromoBanner__text, .SpecialPromoBanner__text-mobile {
      filter: brightness(2) drop-shadow(0px 0px 4px var(--promo-highlight));
    }
  }

  .SpecialPromoBanner__text, .SpecialPromoBanner__text-mobile {
    @apply promo-t-gradient promo-t-gradient-animated;
    animation-duration: 5s;
    filter: brightness(1) drop-shadow(0px 0px 0px var(--promo-highlight));
  }
}
</style>